import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Typography, AppBar, Toolbar } from '@mui/material';

/**
 * ClientLayout component
 * A minimal layout for client-facing pages without navigation to other parts of the application
 */
const ClientLayout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Audit Management System
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Outlet />
      </Container>
      
      <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto', backgroundColor: (theme) => theme.palette.grey[200] }}>
        <Container maxWidth="sm">
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Audit Management System
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default ClientLayout;
